import React, { useEffect } from "react";
import FuturePurchaseFollowupNoteListing from "./FuturePurchaseFollowupNoteListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
  setIsOpenAddDialog,
} from "src/redux/slices/FuturePurchaseFollowupSlice";
import { useParams } from "react-router-dom";
import { useGetAllFollowupNoteDataQuery } from "src/services/FollowupNoteService";
import FollowupFormWrapper from "../AddNote/AddFollowupNoteWrapper";

type Props = {};

const FuturePurchaseFollowupNoteListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage,isOpenAddDialog, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.followupNotes);

  const { futurePurchaseId } = useParams();
  const { data, isLoading, isFetching } = useGetAllFollowupNoteDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["mobile"],
    page: page,
    filterBy: [
      {
        fieldName: "futurePurchaseId",
        value: futurePurchaseId,
      },
    ],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    {
      field: "nextfollowupNoteDate",
      headerName: "Date ",

      flex: "flex-[1.5_1.5_0%]",
    },

    {
      field: "note",
      headerName: "Followup Note",
      flex: "flex-[1.5_1.5_0%]",
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <div className="capitalize text-[13px]"> {row?.mobile} </div>
      ),
    },
  ];

  return (
    <div>
      <FuturePurchaseFollowupNoteListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
        }}
      />
      {isOpenAddDialog ? (
        <FollowupFormWrapper
          onClose={() => dispatch(setIsOpenAddDialog(false))}
          selectedFuturePurchaseId={futurePurchaseId}
        />
      ) : null}
    </div>
  );
};

export default FuturePurchaseFollowupNoteListingWrapper;
